<div class="page-header">
	<h1 class="page-title" *ngIf="loading == false && mode == 'New'">Create Role</h1>
	<h1 class="page-title" *ngIf="loading == false && mode == 'Edit'">Modify Role</h1>
	<h1 class="page-title" *ngIf="loading == true">Loading</h1>
</div>

<nz-tabset [nzTabPosition]="'top'" nzType="card" nzSize="small" [nzSelectedIndex]="selectedTabIndex" (nzSelectedIndexChange)="selectedTabIndex = $event">
	<nz-tab [nzTitle]="'Partner'" class="m-0">
		<form *ngIf="roleForm" [formGroup]="roleForm" (ngSubmit)="doSubmit()">
			<div class="container">
				<div class="row">
					<div class="col">
						<div class="card">
							<div class="card-header">
								<h3>Role Form</h3>
							</div>
							<div class="card-body">
								<div class="form-floating mb-3">
									<input type="text" class="form-control" formControlName="name" id="name" placeholder="Name">
									<label for="name">Role Name</label>
								</div>
								<div class="form-floating mb-3">
									<input type="text" class="form-control" formControlName="description" id="description" placeholder="Description">
									<label for="name">Description</label>
								</div>
								<button type="submit" class="float-end btn btn-primary">Submit</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</form>
	</nz-tab>
	<ng-container *ngIf="roleId">
		<nz-tab [nzTitle]="'Change history'" class="m-0" *hasPermission="['AuditModificationList']">
			<app-audit-timeline *ngIf="selectedTabIndex == 1" [audits]="(modifications! | async)!" [downloadHeading]="'Role Audit'" [downloadName]="'role_audit'"></app-audit-timeline>
		</nz-tab>
	</ng-container>
</nz-tabset>

